// Lib
import gql from 'graphql-tag';

// Types
import { AUTH } from '../types';

export const authIndexUpdatesSubscription = gql`
  subscription authIndexUpdates {
    authIndexUpdates {
      _id
      status
      auth {
        _id
        status
      }
    }
  }
`;

export const authGroupAuthImportResults = gql`
  subscription AuthGroupAuthImportResults {
    authGroupAuthImportResults {
      topic
      accountId
      createdAt
      groupId
      totalItems
      currentIndex
      data {
        ${AUTH}
      }
    }
  }
`;
